import React from 'react';


class MatchMutedComponent extends React.Component
{
	render(){
		const match = this.props.chatMessages.match;
		if(!match)
		{
			return null;
		}
		if(!match.match_muted)
		{
			return null;
		}
		return (
			<div className='match_muted_notification'>
				You are currently match chat restricted until {match.match_muted.until.format('LLLL')}
			</div>
		)
	}

}

export {MatchMutedComponent}